import React from 'react';
import { Phone } from '@phosphor-icons/react';
import { usePersona, personas } from './PersonaContext';
export function MobileCTABar() {
  const {
    persona
  } = usePersona();
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-hairline z-50 p-3 flex gap-2.5" data-id="element-309">
      <a href="tel:+61863179998" className="flex-1 flex justify-center items-center py-3 border border-hairline text-charcoal font-semibold rounded-md text-sm active:bg-off-white" data-id="element-310">
        <Phone size={16} weight="regular" className="mr-2" data-id="element-311" />
        Call
      </a>
      <a href="#lead" className="flex-[2] flex flex-col justify-center items-center py-2 bg-knight-orange text-white font-semibold rounded-md text-sm active:bg-knight-orange-hover" data-id="element-312">
        <span data-id="element-313">
          Book {persona ? `as ${personas[persona].shortLabel}` : 'Consultation'}
        </span>
        {persona && <span className="font-mono text-[9px] uppercase tracking-wider opacity-75 mt-0.5" data-id="element-314">
            Path selected
          </span>}
      </a>
    </div>;
}